<div class="matching-selection">
    <div class="question question-{{id}} {{class}}">
        <div class="question-text"><div class="text">{{{t text}}}</div></div>
        {{#if blocks}}<div data-region="question-blocks" class="question-blocks"></div>{{/if}}
        <div class="answers-container" data-answer-count="{{answers.length}}">
            {{#each answers}}
                {{#if ../activitySettings.card_question_type}}
                    <div class="question-answer">
                        <div class="front">{{{t text}}}</div>
                        <div class="back">{{{t text}}}</div>
                    </div>
                {{else}}
                    <div class="question-answer">{{{t text}}}</div>
                {{/if}}

            {{/each}}
        </div>
    </div>
</div>